import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.com/docs/use-static-query/
 */
const Image = (props) => {
	const src = props.src;

	const data = useStaticQuery(graphql`
		query {
			placeholderImage: file(relativePath: { eq: "gatsby-astronaut.png" }) {
				childImageSharp {
					fluid(maxWidth: 300) {
						...GatsbyImageSharpFluid
					}
				}
			}
			imageSchritt1: file(relativePath: { eq: "image-schritt-1.jpg" }) {
				childImageSharp {
					fluid(maxWidth: 300) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imageSchritt2: file(relativePath: { eq: "image-schritt-2.jpg" }) {
				childImageSharp {
					fluid(maxWidth: 300) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imageSchritt3: file(relativePath: { eq: "image-schritt-3.jpg" }) {
				childImageSharp {
					fluid(maxWidth: 300) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imageLines: file(relativePath: { eq: "image-lines.png" }) {
				childImageSharp {
					fluid(maxWidth: 1200) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imagePerson1: file(relativePath: { eq: "image-person1.png" }) {
				childImageSharp {
					fluid(maxWidth: 100) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imagePerson2: file(relativePath: { eq: "image-person6.png" }) {
				childImageSharp {
					fluid(maxWidth: 100) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imagePerson3: file(relativePath: { eq: "image-person3.png" }) {
				childImageSharp {
					fluid(maxWidth: 100) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imagePerson4: file(relativePath: { eq: "image-person4.png" }) {
				childImageSharp {
					fluid(maxWidth: 100) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imagePerson5: file(relativePath: { eq: "image-person5.png" }) {
				childImageSharp {
					fluid(maxWidth: 100) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imageAdrian: file(relativePath: { eq: "image-adrian.jpg" }) {
				childImageSharp {
					fluid(maxWidth: 300) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imageAmelie: file(relativePath: { eq: "image-amelie.jpg" }) {
				childImageSharp {
					fluid(maxWidth: 300) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imageThomas: file(relativePath: { eq: "image-thomas.jpg" }) {
				childImageSharp {
					fluid(maxWidth: 300) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imageTeamAlpha: file(relativePath: { eq: "image-team-alpha.png" }) {
				childImageSharp {
					fluid(maxWidth: 300) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imageTeam: file(relativePath: { eq: "image-team.jpg" }) {
				childImageSharp {
					fluid(maxWidth: 300) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imageTeamNormal: file(relativePath: { eq: "image-team-normal.jpg" }) {
				childImageSharp {
					fluid(maxWidth: 300) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			imageGlobe: file(relativePath: { eq: "image-globe.png" }) {
				childImageSharp {
					fluid(maxWidth: 500) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
		}
	`);

	if (!data?.placeholderImage?.childImageSharp?.fluid) {
		return <div>Picture not found</div>;
	}

	return <Img fluid={data[src].childImageSharp.fluid} />;
};

export default Image;
